import { env } from "../../datas.config";

export function mySetterConversationsInbox(convers, setMessages) {
  const conversationsAvecUnMessageMin = convers
    .filter((canal) => canal.lastMessage?.contenu != null)
    .sort((a, b) => (b.lastMessage?.timeUnix || 0) - (a.lastMessage?.timeUnix || 0));
  setMessages(conversationsAvecUnMessageMin);
}

export function getConversationsGroupe(user, setGroupes, workspaceId) {
  let url = `${env.domain}/api/auth/conversations/groupe`;
  if (workspaceId) url += `?workspaceId=${workspaceId}`;
  fetch(url, {
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  })
    .then((res) => {
      return res.json();
    })
    .then((convers) => {
      let conversationsAvecUnMessageMin = convers.conversations;
      // .filter(
      //   (canal) => canal.lastMessage === "" && canal.groupeInfo === user.userId
      // );
      setGroupes(
        conversationsAvecUnMessageMin.sort((a, b) => {
          return (b.lastMessage?.timeUnix || 0) - (a.lastMessage?.timeUnix || 0);
        })
      );
    })
    .catch((erreur) => {
      console.error(erreur);
    });
}
